export enum EContactFlag {
	userContactInitialized = "userContactInitialized"
}